export default (function(window, document) {

  function init() {

    const hamButton = document.querySelector('.expand-button')
    let hideHandler = null
    let showHandler = null

    if (!hamButton) {
      return
    }

    hamButton.addEventListener('click', (e) => {
      e.preventDefault();

      const menu = document.querySelector('.expanded-content')
      const header = document.querySelector('.expand')
      if (menu.classList.contains('active')) {
        hide()
        return
      }
      show()
    })

    document.addEventListener('keyup', (e) => {
      // Not the escape key. Quit early
      if (e.keyCode !== 27) {
        return;
      }

      const menu = document.querySelector('.expanded-content')
      const header = document.querySelector('.expand')
      menu.classList.remove('active')
      header.classList.remove('open')
    })
  }

  function show() {
    return new Promise((resolve, reject) => {
      const menu = document.querySelector('.expanded-content')
      const header = document.querySelector('.expand')
      menu.classList.add('active')
      header.classList.add('open')

      // showHandler = (e) => {
      //   if (e.target.classList.contains('.expanded-content')) {
      //     resolve()
      //   }

      //   menu.removeEventListener('transitionend', showHandler)
      // }

      // menu.addEventListener('transitionend', showHandler)
    })
  }

  function hide() {
    return new Promise((resolve, reject) => {
      const menu = document.querySelector('.expanded-content')
      const header = document.querySelector('.expand')
      menu.classList.remove('active')
      header.classList.remove('open')

      // hideHandler = (e) => {
      //   if (e.target.classList.contains('.expanded-content')) {
      //     resolve()
      //   }

      //   menu.removeEventListener('transitionend', hideHandler)
      // }

      // menu.addEventListener('transitionend', hideHandler)
    })
  }

  function isActive() {
    const menu = document.querySelector('.expanded-content')
    return menu.classList.contains('active')
  }


  return {
    init,
    show,
    hide,
    isActive,
  }

})(window, document);
